module.exports = __webpack_public_path__ + "img/267.dad4c361.jpg";